import { render, staticRenderFns } from "./serviceFee.vue?vue&type=template&id=9edaabec&scoped=true"
import script from "./serviceFee.vue?vue&type=script&lang=js"
export * from "./serviceFee.vue?vue&type=script&lang=js"
import style0 from "./serviceFee.vue?vue&type=style&index=0&id=9edaabec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edaabec",
  null
  
)

export default component.exports